import { useEffect, useRef } from "react";
import { ArrowTurnDownLeftIcon } from "@heroicons/react/24/outline";
import { Input, DropdownItem } from "@components";

const StringEditor = ({ title, value, onChange, onClose }) => {
  const inputRef = useRef(null);

  useEffect(() => {
    const id = setTimeout(() => inputRef.current?.focus(), 0);
    return () => clearTimeout(id);
  }, []);

  return (
    <DropdownItem unstyled>
      <div className="relative">
        <Input
          type="text"
          innerRef={inputRef}
          placeholder={`Filter by ${title}...`}
          value={value}
          className="pr-9"
          onKeyDown={(e) => {
            if (e.key === " ") e.stopPropagation();
            if (e.key === "Enter") {
              e.preventDefault();
              onClose?.();
            }
          }}
          onChange={(e) => onChange(e.target.value)}
        />
        <button
          type="button"
          tabIndex={-1}
          onClick={onClose}
          aria-label="Apply filter"
          className="absolute right-2 top-1/2 -translate-y-1/2 p-1 rounded text-zinc-400 hover:bg-zinc-100 hover:text-zinc-600"
        >
          <ArrowTurnDownLeftIcon className="size-4" />
        </button>
      </div>
    </DropdownItem>
  );
};

export default StringEditor;
